/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Notifications_Tags_Bell_UpdateInputs */

const he_notifications_tags_bell_update = /** @type {(inputs: Notifications_Tags_Bell_UpdateInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`עדכון הגדרות התראות תגיות`)
};

const en_notifications_tags_bell_update = /** @type {(inputs: Notifications_Tags_Bell_UpdateInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Update tag notification settings`)
};

/**
* | output |
* | --- |
* | "Update tag notification settings" |
*
* @param {Notifications_Tags_Bell_UpdateInputs} inputs
* @param {{ locale?: "he" | "en" }} options
* @returns {LocalizedString}
*/
export const notifications_tags_bell_update = /** @type {((inputs?: Notifications_Tags_Bell_UpdateInputs, options?: { locale?: "he" | "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Notifications_Tags_Bell_UpdateInputs, { locale?: "he" | "en" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "he") return he_notifications_tags_bell_update(inputs)
	return en_notifications_tags_bell_update(inputs)
});